import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import api from '../services/api';
import { ArrowLeft, ExternalLink } from 'lucide-react';

const P2POrdersHistoryPage = () => {
    const navigate = useNavigate();
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchOrders();
    }, []);

    const fetchOrders = async () => {
        try {
            const res = await api.get('/p2p/orders');
            setOrders(res.data.orders);
        } catch (error) {
            console.error('Failed to fetch orders:', error);
        } finally {
            setLoading(false);
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'completed': return 'text-green-500 bg-green-500/10';
            case 'cancelled': return 'text-red-500 bg-red-500/10';
            case 'paid': return 'text-yellow-500 bg-yellow-500/10';
            default: return 'text-blue-500 bg-blue-500/10';
        }
    };

    return (
        <div className="min-h-screen bg-[#0b0e11] text-gray-100 font-sans">
            <Navbar />

            <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <div className="flex items-center gap-4 mb-8">
                    <button
                        onClick={() => navigate('/p2p')}
                        className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
                    >
                        <ArrowLeft size={24} />
                    </button>
                    <h1 className="text-3xl font-bold text-white">My P2P Orders</h1>
                </div>

                <div className="bg-[#181a20] rounded-3xl border border-gray-800 overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead>
                                <tr className="border-b border-gray-800 text-left">
                                    <th className="p-6 text-sm font-medium text-gray-400">Order ID</th>
                                    <th className="p-6 text-sm font-medium text-gray-400">Type</th>
                                    <th className="p-6 text-sm font-medium text-gray-400">Asset</th>
                                    <th className="p-6 text-sm font-medium text-gray-400">Amount</th>
                                    <th className="p-6 text-sm font-medium text-gray-400">Price</th>
                                    <th className="p-6 text-sm font-medium text-gray-400">Total (Fiat)</th>
                                    <th className="p-6 text-sm font-medium text-gray-400">Status</th>
                                    <th className="p-6 text-sm font-medium text-gray-400">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="8" className="p-8 text-center text-gray-500">Loading orders...</td>
                                    </tr>
                                ) : orders.length > 0 ? (
                                    orders.map(order => (
                                        <tr key={order.id} className="border-b border-gray-800 hover:bg-gray-800/50 transition-colors">
                                            <td className="p-6 text-sm font-mono text-gray-500">#{order.id.slice(0, 8)}</td>
                                            <td className="p-6">
                                                <span className={`font-bold ${order.P2PAd?.type === 'buy' ? 'text-red-500' : 'text-green-500'}`}>
                                                    {order.P2PAd?.type === 'buy' ? 'SELL' : 'BUY'}
                                                </span>
                                            </td>
                                            <td className="p-6 font-bold text-white">{order.P2PAd?.asset}</td>
                                            <td className="p-6 text-gray-300">{parseFloat(order.amount).toFixed(6)}</td>
                                            <td className="p-6 text-gray-300">{parseFloat(order.price).toFixed(2)}</td>
                                            <td className="p-6 font-bold text-white">
                                                {parseFloat(order.fiatAmount).toFixed(2)} {order.P2PAd?.fiatCurrency}
                                            </td>
                                            <td className="p-6">
                                                <span className={`px-3 py-1 rounded-full text-xs font-bold ${getStatusColor(order.status)}`}>
                                                    {order.status.toUpperCase()}
                                                </span>
                                            </td>
                                            <td className="p-6">
                                                <button
                                                    onClick={() => navigate(`/p2p/orders/${order.id}`)}
                                                    className="p-2 text-blue-400 hover:text-blue-300 hover:bg-blue-400/10 rounded-lg transition-colors"
                                                >
                                                    <ExternalLink size={18} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="p-12 text-center text-gray-500">No orders found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default P2POrdersHistoryPage;
